import { _ } from "~/i18n";
import { node, getPremiumIconSrc } from "~/util/dom";
import { openPropositionDialog } from "~/util/premium";

export default class RouteReadOnlyInfo {
	_container: HTMLParagraphElement;

	_visible: boolean;

	constructor() {
		this._container = node("p", { className: "route-read-only-info" });
		this._visible = false;

		this._build();
	}

	destroy() {
		this._container.remove();
	}

	get container() {
		return this._container;
	}

	set visibility(state: boolean) {
		this._visible = state;

		this._updateVisibility();
	}

	_build() {
		this._container.innerHTML = _("route.readOnlyOnboarding", {
			logo: `<img src="${getPremiumIconSrc()}" alt="" />`,
			link: `<a href="#">${_("premium.proposition.popup.premium")}</a>`,
		});

		const link = this._container.querySelector("a") as HTMLAnchorElement;

		link.setAttribute("data-log-action", "transportTypePremium_premiumPurchase_show");

		link.addEventListener("click", event => {
			event.stopPropagation();
			event.preventDefault();
			openPropositionDialog("transportTypePremium");
		});
	}

	_updateVisibility() {
		this._container.classList[this._visible ? "add" : "remove"]("visible");
	}
}
